import { VideoTypeId, VideoTypes } from 'components/Contentful/VideoPlayer';
import { ReactElement } from 'react';
import { IFragmentVimeoVideo } from 'types/contentful';

export const isVimeoVideoGuard = (videoObject: VideoTypes): videoObject is IFragmentVimeoVideo => {
  return (videoObject as IFragmentVimeoVideo).sys.contentType.sys.id === VideoTypeId.Vimeo;
};

type Props = {
  video: IFragmentVimeoVideo;
  isAutoPlay?: boolean;
  isMuted?: boolean;
  isLooped?: boolean;
};

export default function Vimeo({
  video,
  isAutoPlay = false,
  isMuted = false,
  isLooped = true,
}: Props): ReactElement {
  const src = `https://player.vimeo.com/video/${
    video?.fields?.videoId
  }?title=0&byline=0&portrait=0&autoplay=${isAutoPlay ? '1' : '0'}&muted=${
    isMuted ? '1' : '0'
  }&loop=${isLooped ? '1' : '0'}&background=1`;

  return (
    <>
      <iframe
        title="video"
        src={src}
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      ></iframe>
      <script src="https://player.vimeo.com/api/player.js"></script>
    </>
  );
}
